<template>
    <div>
        <modal
            class="new-modal-small"
            :name="modal_name"
            transition="nice-modal-fade"
            :delay="100"
            height="auto"
            :min-height="200"
            :min-width="400"
            :pivot-y="0.5"
            :adaptive="true"
            :scrollable="false"
            style="pointer-events:inherit !important" 
            v-bind:click-to-close="false"
        >
            <div class="v-modal-content d-flex flex-column justify-content-center align-items-center text-center" style="background-color: #fff !important; height: 30em !important;">
                <img src="/static/images/trash-big.svg" style="height: 10rem !important" />
                <div class="mt-5" style="font-size: 16px">
                    <div class="mb-4" style="font-size: 20px; color: #f30d0d">Delete Customer</div>
                    <span v-if="selected_data.length == 1">Do you want to delete selected customer ?</span>
                    <span v-else>Do you want to delete selected customers ?</span>
                </div>
                <div v-if="disableButtonAndDisplayLoader == false" class="d-flex aligin-items-center justify-content-center mt-6">
                    <button class="btn new-yes-button mr-4 px-4" @click="hideSelf">Cancel</button>
                    <button class="btn new-no-button ml-4 px-4" style="border: 1px solid transparent !important;" @click="confirmDelete">Delete</button>
                </div>
                <div v-else class="d-flex aligin-items-center justify-content-center mt-6">
                    <button class="btn mr-4 px-4" style="border: 1px solid transparent !important;" disabled>Cancel</button>
                    <button class="btn ml-4 px-4" style="border: 1px solid transparent !important;position: relative;" disabled>Delete
                        <hollow-dots-spinner style="position: absolute;margin: 0;top: 22px;display: flex;justify-content: center;width: 100% !important;" :animation-duration="1200" :dot-size="10" :dots-num="3" :color="'#00448b'" />
                    </button>
                </div>
            </div>
        </modal>
    </div>
</template>

<script>
import { HollowDotsSpinner } from "epic-spinners";
export default {
    data(){
        return{
            disableButtonAndDisplayLoader: false,
        }
    },
    props: ["modal_name", "selected_data"],
    components: {
        HollowDotsSpinner
    },
    methods: {
        hideSelf() {
            this.$emit("cancelDelete");
            this.$modal.hide(this.modal_name);
        },
        confirmDelete() {
            this.disableButtonAndDisplayLoader = true;
            this.$emit("deleteCustomers");
            setTimeout(() => {
                this.disableButtonAndDisplayLoader = false;
                this.$modal.hide(this.modal_name);
            }, 1500);
        }
    }
}
</script>
<style>
    .new-yes-button{
        background-color: #fff !important;
        color: #00448b !important;
        border: 1px solid #00448b !important;
    }
    .new-yes-button:hover{
        background-color: #00448b !important;
        color: #fff !important;
        border: 1px solid #00448b !important;
    }
</style>


// WEBPACK FOOTER //
// src/components/alertModals/DeleteCustomer.vue